// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-form {
  visibility: hidden;
  position: fixed;
  display: flex;
  width: 20rem;
  top: 10rem;
  flex-direction: column;
  background-color: white;
  z-index: 1;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.25);
  border-radius: 1rem;
}
.upload-form__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 3rem;
  border-bottom: 0.0625rem solid #ddd;
}
.upload-form__header__title {
  margin-left: 2rem;
  font-size: 1rem;
  color: #000;
}
.upload-form__header__close {
  scale: 0.7;
  cursor: pointer;
}
.upload-form__title {
  color: #000;
  font-size: 2rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.upload-form__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 2rem;
}
.upload-form__content__button {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #4BABB9;
  color: white;
  width: 11rem;
  height: 2rem;
  border-radius: 0.625rem;
  align-self: center;
  cursor: pointer;
}
.upload-form__content__file-upload {
  text-wrap: wrap;
}

.visible {
  visibility: visible !important;
  opacity: 1;
  transition: visibility 0s, opacity 0.5s linear;
}`, "",{"version":3,"sources":["webpack://./src/features/admin/components/upload-form/upload-form.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;AAER;AADQ;EACI,iBAAA;EACA,eAAA;EACA,WAAA;AAGZ;AADQ;EACI,UAAA;EAEA,eAAA;AAEZ;AACI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AACR;AACQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AACZ;AACQ;EACI,eAAA;AACZ;;AAIA;EACI,8BAAA;EACA,UAAA;EACA,8CAAA;AADJ","sourcesContent":[".upload-form{\n    visibility: hidden;\n    position: fixed;\n    display: flex;\n    width: 20rem;\n    top:10rem;\n    flex-direction: column;\n    background-color: white;\n    z-index: 1;\n    box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.25);\n    border-radius: 1rem;\n    &__header{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        height: 3rem;\n        border-bottom: 0.0625rem solid #ddd;\n        &__title{\n            margin-left: 2rem;\n            font-size: 1rem;\n            color: #000;\n        }\n        &__close{\n            scale: 0.7;\n            \n            cursor: pointer;\n        }\n    }\n    &__title{\n        color: #000;\n        font-size: 2rem;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n    }\n    &__content{\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin: 2rem;\n\n        &__button{\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: #4BABB9;\n            color: white;\n            width: 11rem;\n            height: 2rem;\n            border-radius: 0.625rem;\n            align-self: center;\n            cursor: pointer;\n        }\n        &__file-upload{\n            text-wrap: wrap;\n        }\n    }\n\n}\n.visible{\n    visibility: visible !important;\n    opacity: 1;\n    transition: visibility 0s, opacity 0.5s linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
